import React from 'react';

const BestMixturesCard = ({ mixtures = [], onShowAll }) => {
  // Helper function to format CO2 text with subscript
  const formatCO2 = (text) => {
    return text.replace('CO2', 'CO<sub>2</sub>');
  };

  return (
    <div className="mb-8">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold">Beste Mischgüter</h2>
        <button
          className="text-sm text-green-600 hover:text-green-700"
          onClick={onShowAll}
        >
          Alle anzeigen
        </button>
      </div>
      <div className="space-y-4">
        {mixtures.slice(0, 3).map((mixture, index) => (
          <div key={mixture.id || index} className="flex items-center justify-between">
            <div>
              <div className="font-medium text-sm">{mixture.name}</div>
              <div className="text-xs text-gray-500">{mixture.category}</div>
              <div className="text-sm text-green-600" dangerouslySetInnerHTML={{ __html: formatCO2(mixture.sales) }} />
            </div>
            <div className="font-medium text-green-600 whitespace-nowrap">
              {mixture.stock}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BestMixturesCard;
